<template>
	<v-app>
		<v-app-bar app>
			<v-toolbar-title>Zeitrechner</v-toolbar-title>
		</v-app-bar>

		<v-main class="ma-2">
			<v-container fill-height fluid>
				<v-img
					:src="require('./assets/logo.svg')"
					class="my-10"
					contain
					@click="snackbar_credits.show = true"
				/>
				<v-row>
					<v-col class="d-flex justify-center align-center text-h5">
						{{ ergebnisZeitText }}
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6" class="d-flex justify-center align-center">
						{{ startZeitText }}
					</v-col>
					<v-col cols="6" class="d-flex justify-center align-center">
						{{ endZeitText }}
					</v-col>
					<v-col>
						<v-dialog
							ref="dialog1"
							v-model="modal1"
							:return-value.sync="timeA_Value"
							persistent
							width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn block elevation="2" v-bind="attrs" v-on="on"
									>Zeit Auswahl</v-btn
								>
							</template>
							<v-time-picker
								v-if="modal1"
								v-model="timeA_Clock"
								full-width
								format="24hr"
							>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="modal1 = false">
									Abbrechen
								</v-btn>
								<v-btn
									text
									color="primary"
									@click="$refs.dialog1.save(timeA_Clock)"
								>
									OK
								</v-btn>
							</v-time-picker>
						</v-dialog>
					</v-col>
					<v-col>
						<v-dialog
							ref="dialog2"
							v-model="modal2"
							:return-value.sync="timeB_Value"
							persistent
							width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn block elevation="2" v-bind="attrs" v-on="on"
									>Zeit Auswahl</v-btn
								>
							</template>
							<v-time-picker
								v-if="modal2"
								v-model="timeB_Clock"
								full-width
								format="24hr"
							>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="modal2 = false">
									Abbrechen
								</v-btn>
								<v-btn
									text
									color="primary"
									@click="$refs.dialog2.save(timeB_Clock)"
								>
									OK
								</v-btn>
							</v-time-picker>
						</v-dialog>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-checkbox
							v-model="timeModifiers"
							label="15m Pause"
							color="primary"
							value="15mPause"
							hide-details
						></v-checkbox>
					</v-col>
					<v-col>
						<v-checkbox
							v-model="timeModifiers"
							label="30m Pause"
							color="primary"
							value="30mPause"
							hide-details
						></v-checkbox>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-checkbox
							v-model="timeModifiers"
							label="Benutzerdefiniert"
							color="primary"
							value="Benutzerdefiniert"
							hide-details
						></v-checkbox>
					</v-col>
					<v-col>
						<v-text-field
							v-model="modifierCustomTime"
							hide-details
							single-line
							type="number"
							min="0"
							:rules="[rules.customPause]"
						></v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-btn block elevation="2" @click="calculateTime">Berechnen</v-btn>
					</v-col>
				</v-row>
				<v-row no-gutters>
					<v-col>
						<p class="d-flex justify-end">v0.2</p>
					</v-col>
				</v-row>
			</v-container>

			<v-snackbar
				v-model="snackbar_credits.show"
				:timeout="snackbar_credits.timeout"
				rounded="pill"
				absolute
				class="text-center justify-center"
			>
				{{ snackbar_credits.text }}
			</v-snackbar>

			<v-snackbar
				absolute
				bottom
				:value="updateExists"
				:timeout="-1"
				color="primary"
			>
				Ein Update ist verfügbar
				<v-btn text @click="refreshApp"> Update </v-btn>
			</v-snackbar>
		</v-main>
	</v-app>
</template>

<script>
import update from "./mixins/update";

export default {
	data() {
		return {
			timeA_Clock: null,
			timeA_Value: null,
			timeB_Clock: null,
			timeB_Value: null,
			modal1: false,
			modal2: false,
			timeModifiers: [],
			modifierCustomTime: null,
			timeResult: null,
			snackbar_credits: {
				show: false,
				text: "App by Fuchs Dominik (DF)",
				timeout: 2000,
			},
			rules: {
				customPause: (value) => {
					if (
						this.timeModifiers.includes("Benutzerdefiniert") &&
						(value === null || value < 0)
					) {
						return false;
					}
					return true;
				},
			},
		};
	},
	watch: {
		modal1: function (val) {
			if (val == true) {
				var d = new Date();
				let tmp =
					d.getHours().toString().padStart(2, "0") +
					":" +
					d.getMinutes().toString().padStart(2, "0");
				this.timeA_Clock = tmp;
			}
		},
		modal2: function (val) {
			if (val == true) {
				var d = new Date();
				let tmp =
					d.getHours().toString().padStart(2, "0") +
					":" +
					d.getMinutes().toString().padStart(2, "0");
				this.timeB_Clock = tmp;
			}
		},
	},
	computed: {
		startZeitText: function () {
			if (this.timeA_Value === null) {
				return "Startzeit";
			}

			return "Start: " + this.timeA_Value;
		},
		endZeitText: function () {
			if (this.timeB_Value === null) {
				return "Endzeit";
			}

			return "Ende: " + this.timeB_Value;
		},
		ergebnisZeitText: function () {
			if (this.timeResult === null) {
				return "Zeiten auswählen";
			}

			if (this.timeResult == -1337) {
				return "¯\\_(ツ)_/¯";
			}

			return "Dauer: " + this.timeResult + " Minuten";
		},
	},
	methods: {
		calculateTime() {
			if (this.timeA_Value === null) {
				return;
			}

			if (this.timeB_Value === null) {
				return;
			}

			let tmp = this.timeA_Value.split(":");
			let startTime = parseInt(tmp[0], 10) * 60 + parseInt(tmp[1], 10);

			tmp = this.timeB_Value.split(":");
			let endTime = parseInt(tmp[0], 10) * 60 + parseInt(tmp[1], 10);

			let finalTime = endTime - startTime;

			if (startTime > endTime) {
				this.timeResult = -1337;
				return;
			}

			if (this.timeModifiers.includes("15mPause")) {
				finalTime = finalTime - 15;
			}

			if (this.timeModifiers.includes("30mPause")) {
				finalTime = finalTime - 30;
			}

			if (this.timeModifiers.includes("Benutzerdefiniert")) {
				if (this.modifierCustomTime === null) {
					return;
				}

				finalTime = finalTime - this.modifierCustomTime;
			}

			this.timeResult = finalTime;
		},
	},
	mixins: [update],
};
</script>
<style>
html {
	position: fixed;
	height: 100%;
	overflow: hidden;
	background-color: black;
}

body {
	width: 100vw;
	height: 100vh;
	overflow-y: scroll;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
}
.v-time-picker-title {
	justify-content: center !important;
}
</style>
